import { useEffect, useRef } from 'react';
import type { TranscriptEntry } from '@mia/shared';

interface TranscriptViewProps {
  entries: TranscriptEntry[];
}

export default function TranscriptView({ entries }: TranscriptViewProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [entries]);

  if (entries.length === 0) {
    return (
      <div className="flex h-full items-center justify-center text-surface-500">
        <p>Transcript will appear here...</p>
      </div>
    );
  }

  return (
    <div ref={containerRef} className="h-full overflow-y-auto space-y-4 p-4">
      {entries.map((entry) => (
        <div
          key={entry.id}
          className={`flex ${entry.role === 'user' ? 'justify-end' : 'justify-start'}`}
        >
          <div
            className={`max-w-[80%] rounded-2xl px-4 py-3 ${
              entry.role === 'user'
                ? 'bg-primary-600 text-white rounded-br-md'
                : entry.role === 'agent'
                ? 'bg-surface-800 text-surface-100 rounded-bl-md'
                : 'bg-surface-700/50 text-surface-400 text-sm italic'
            } ${!entry.isFinal ? 'opacity-70' : ''}`}
          >
            <p className="text-sm leading-relaxed">{entry.content}</p>
            <p
              className={`mt-1 text-xs ${
                entry.role === 'user' ? 'text-primary-200' : 'text-surface-500'
              }`}
            >
              {new Date(entry.timestamp).toLocaleTimeString()}
              {!entry.isFinal && ' (typing...)'}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}




